import t from"./Stats.vue_vue&type=script&lang.js";import{render as e}from"./Stats.vue_vue&type=template&id=7337491f&lang.js";t.render=e,t.__file="src/components/Stats.vue";export default t;
//# sourceMappingURL=Stats.vue.js.map
